// Contenu détaillé pour chaque solution — ouvert via modal depuis la grille des solutions

export const SOLUTIONS_DETAIL = {
  solar: {
    id: "solar",
    title: "Panneaux photovoltaïques",
    subtitle: "Produisez votre propre électricité et divisez votre facture par 2 à 3.",
    hero: "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBhbmVscyUyMHJvb2Z8ZW58MHx8fHwxNzkwNzc4MTM5fDA&ixlib=rb-4.1.0&q=85",
    intro:
      "Panneaux monocristallins nouvelle génération 400 à 500 Wc, garantis 25 ans en production. Installation clé en main par nos équipes certifiées RGE QualiPV : étude d'ensoleillement, calepinage, pose, raccordement Enedis et suivi de production.",
    why: [
      { title: "-70% sur la facture", body: "Autoconsommer votre production divise durablement la facture d'électricité." },
      { title: "Vendre le surplus", body: "Contrat EDF OA d'achat sur 20 ans — un revenu passif garanti." },
      { title: "Valorise le bien", body: "Un logement équipé se vend +5 à +9% selon la surface installée." },
      { title: "MaPrimeRénov' + CEE", body: "Prime à l'autoconsommation + éco-PTZ — on monte tous les dossiers." },
      { title: "25 ans de garantie", body: "Production garantie à 85% après 25 ans par le fabricant." },
      { title: "Écologique", body: "1 kWc évite environ 400 kg de CO₂ par an." },
    ],
    process: [
      { step: "01", title: "Étude technique gratuite", body: "Analyse d'ensoleillement, orientation, ombrages, structure de toiture." },
      { step: "02", title: "Devis chiffré sous 48 h", body: "Prix ferme, montant des aides simulé, temps de retour calculé." },
      { step: "03", title: "Pose en 1 à 3 jours", body: "Chantier propre, sans percement inutile, raccordement compris." },
      { step: "04", title: "Suivi 25 ans", body: "Monitoring temps réel + hotline dépannage et maintenance annuelle." },
    ],
    projects: [
      {
        title: "Chantier HMCD — Maison familiale · Île-de-France",
        power: "Panneaux monocristallins + onduleur hybride",
        result: "Pose équipe HMCD · Livraison satisfaite en famille",
        collage:
          "https://customer-assets-jai6qajn.emergentagent.net/job_energie-habitat-pro/artifacts/c71uh6dx_Image%20ChatGPT%2030%20sept.%202026%2C%2021_12_03.png",
      },
      {
        title: "Maison — Levallois-Perret",
        power: "7 kWc + batterie 10 kWh",
        result: "80% d'autoconsommation · DPE E → A",
        before: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        after: "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      },
      {
        title: "Villa — Neuilly-sur-Seine",
        power: "12 kWc premium",
        result: "Autoconsommation optimisée · DPE passé de D à A",
        before: "https://images.unsplash.com/photo-1518780664697-55e3ad937233?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        after: "https://images.unsplash.com/photo-1658298775754-5839ffd434cc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      },
    ],
    testimonial: {
      quote:
        "En 8 mois nous couvrons déjà 78% de notre consommation. L'application mobile est claire, on voit en direct combien on produit.",
      author: "Céline P.",
      role: "Levallois-Perret · Installation 2024",
    },
    stats: [
      { value: "420+", label: "Toitures équipées" },
      { value: "1,2 GWh", label: "Produits par an" },
      { value: "25 ans", label: "Garantie production" },
      { value: "8 ans", label: "Retour moyen" },
    ],
  },

  ite: {
    id: "ite",
    title: "Isolation thermique par l'extérieur",
    subtitle:
      "Enveloppez votre maison d'un manteau isolant. Confort été comme hiver, façade neuve, DPE bondissant.",
    hero: "https://images.unsplash.com/photo-1590674899484-d5640e854abe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
    intro:
      "L'ITE traite en une seule opération 80% des déperditions thermiques d'une maison. Nous posons polystyrène graphité, laine de roche ou fibre de bois selon votre configuration, avec finition enduit minéral ou bardage. Certification Qualibat 7141.",
    why: [
      { title: "-40 à -60% de chauffage", body: "L'enveloppe traitée supprime la quasi-totalité des ponts thermiques." },
      { title: "Confort d'été", body: "Le bâti stocke moins la chaleur — jusqu'à 5°C d'écart en été sans clim." },
      { title: "Sans perdre de surface", body: "Contrairement à l'isolation intérieure, vos m² habitables restent intacts." },
      { title: "Façade neuve", body: "Enduit, bardage bois, composite ou brique — au choix, avec 20 ans de garantie." },
      { title: "MaPrimeRénov' Sérénité", body: "Jusqu'à 90% du montant financé sous conditions de revenus." },
      { title: "DPE +2 à +3 lettres", body: "Passage F→C, E→B typique en une seule opération." },
    ],
    process: [
      { step: "01", title: "Diagnostic thermique", body: "Caméra infrarouge, calcul U des parois, choix de l'isolant." },
      { step: "02", title: "Choix esthétique", body: "Nuancier finition, échantillons matière, rendu 3D avant travaux." },
      { step: "03", title: "Chantier 2 à 4 semaines", body: "Pose échafaudage, isolant, treillis, sous-couche, finition." },
      { step: "04", title: "Contrôle final", body: "Test étanchéité à l'air, PV de réception, garantie décennale." },
    ],
    projects: [
      {
        title: "Chantier HMCD — Rénovation complète façade",
        power: "ITE + enduit finition + traitement des ponts thermiques",
        result: "Façade fissurée & tachée transformée en façade neuve",
        collage:
          "https://customer-assets-jai6qajn.emergentagent.net/job_energie-habitat-pro/artifacts/cwm41zjj_Image%20ChatGPT%2030%20sept.%202026%2C%2021_21_12.png",
      },
      {
        title: "Pavillon années 70 — Nanterre",
        power: "145 m² ITE laine de roche",
        result: "DPE F → C · -58% chauffage · MaPrimeRénov' obtenue",
        before: "https://images.unsplash.com/photo-1518780664697-55e3ad937233?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        after: "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      },
      {
        title: "Maison bourgeoise — Neuilly",
        power: "180 m² ITE enduit chaux",
        result: "DPE D → A · façade classée conservée",
        before: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        after: "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      },
    ],
    testimonial: {
      quote:
        "On est passés de F à C sur le DPE. En hiver, plus besoin de surchauffer, la maison garde la chaleur. Le confort n'a rien à voir.",
      author: "Sabrina & Karim",
      role: "Nanterre · Chantier livré fin 2024",
    },
    stats: [
      { value: "62 000 m²", label: "ITE posée" },
      { value: "-52%", label: "Chauffage moyen" },
      { value: "20 ans", label: "Garantie enduit" },
      { value: "10 ans", label: "Décennale AXA" },
    ],
  },

  hvac: {
    id: "hvac",
    title: "Pompe à chaleur",
    subtitle:
      "Remplacez chaudière fioul ou gaz par une PAC : chauffage propre, économies immédiates, aides massives.",
    hero: "https://images.unsplash.com/photo-1638864311939-2f4c2ef0d5bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
    intro:
      "Pompes à chaleur air/eau, air/air ou géothermie installées par nos frigoristes agréés (attestation de capacité fluides). COP 4,5+ sur les modèles récents : 1 kWh d'électricité produit 4,5 kWh de chaleur. Compatible avec plancher chauffant et radiateurs basse température.",
    why: [
      { title: "-70% sur le chauffage", body: "COP 4,5 signifie que vous divisez votre facture énergétique par 3 à 4." },
      { title: "MaPrimeRénov' XL", body: "Aides importantes pour remplacer une chaudière fioul ou gaz." },
      { title: "Chauffage + climatisation", body: "Les modèles réversibles rafraîchissent l'été — 2 usages, 1 machine." },
      { title: "Fin du fioul obligatoire", body: "Interdiction des chaudières fioul neuves — la PAC est LA solution." },
      { title: "Silencieux", body: "Modèles récents < 40 dB — imperceptible à quelques mètres." },
      { title: "Compatible solaire", body: "Alimentez votre PAC avec vos panneaux : chauffer gratuit en journée." },
    ],
    process: [
      { step: "01", title: "Bilan thermique", body: "Calcul déperditions, choix air/eau ou géothermie selon terrain." },
      { step: "02", title: "Dimensionnement", body: "Puissance ajustée à la maison, pas de surdimensionnement inutile." },
      { step: "03", title: "Installation 2 à 5 jours", body: "Dépose ancienne chaudière comprise, raccordement électrique." },
      { step: "04", title: "Mise en service + réglage", body: "Loi d'eau paramétrée, formation utilisateur, entretien annuel." },
    ],
    projects: [
      {
        title: "Chantier HMCD — Remplacement fioul par PAC air/eau",
        power: "Dépose chaudière fioul → PAC + module hydraulique intérieur",
        result: "Chaufferie modernisée · Extérieur soigné · Aides déduites",
        collage:
          "https://customer-assets-jai6qajn.emergentagent.net/job_energie-habitat-pro/artifacts/bfsdkjjl_Image%20ChatGPT%2030%20sept.%202026%2C%2021_47_10.png",
      },
      {
        title: "Villa — Rueil-Malmaison",
        power: "PAC air/eau 11 kW + plancher chauffant",
        result: "Fioul remplacé · -78% coût chauffage · aides obtenues",
        before: "https://images.unsplash.com/photo-1585771724684-38269d6639fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        after: "https://images.unsplash.com/photo-1638864311939-2f4c2ef0d5bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      },
      {
        title: "Maison — Colombes",
        power: "PAC air/air multi-split 4 unités",
        result: "Chauffage + clim · consommation divisée par 3",
        before: "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
        after: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      },
    ],
    testimonial: {
      quote:
        "On chauffait au fioul, une facture énorme. Depuis l'installation de la PAC on est divisés par 4. En quelques années c'est amorti — et adieu la cuve dans le jardin.",
      author: "Marc L.",
      role: "Rueil-Malmaison · PAC posée en 2023",
    },
    stats: [
      { value: "COP 4,5", label: "Rendement moyen" },
      { value: "Aides XL", label: "MaPrimeRénov'" },
      { value: "3 à 5 ans", label: "Amortissement" },
      { value: "-70%", label: "Facture chauffage" },
    ],
  },

  battery: {
    id: "battery",
    title: "Batterie de stockage",
    subtitle: "Consommez votre solaire même la nuit — jusqu'à 90% d'autoconsommation.",
    hero: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
    intro:
      "Batteries lithium-fer-phosphate (LFP) 5 à 20 kWh, technologie la plus sûre du marché. Sans terre rare, cycle de vie > 6000 charges, garantie 10 ans. Pilotage intelligent qui décide seul quand stocker, consommer ou revendre.",
    why: [
      { title: "80-90% autoconso.", body: "Sans batterie : 30-40%. Avec batterie : jusqu'à 90%." },
      { title: "Coupure secteur = OK", body: "Fonction backup — vos essentiels continuent de tourner." },
      { title: "Pilotage app", body: "Vous voyez ce qui produit, stocke, consomme, en direct." },
      { title: "10 ans garantie", body: "Capacité garantie à 80% après 10 ans." },
    ],
    process: [
      { title: "Étude conso", step: "01", body: "Analyse de vos courbes de charge sur 12 mois." },
      { step: "02", title: "Dimensionnement", body: "5, 10 ou 20 kWh selon votre besoin réel." },
      { step: "03", title: "Installation 1 jour", body: "Local technique ou garage, raccordement onduleur hybride." },
    ],
    projects: [
      {
        title: "Schéma — Solaire seul vs Solaire + batterie",
        power: "Batterie LFP 10 kWh + onduleur hybride",
        result: "Autoconso 40% → 90% · nuit couverte",
        schema: "battery",
      },
    ],
    testimonial: {
      quote:
        "Avec la batterie, on autoconsomme quasi 80 % de notre production. On revend le surplus à EDF OA.",
      author: "Céline P.",
      role: "Levallois-Perret · Batterie 10 kWh",
    },
    stats: [
      { value: "10 kWh", label: "Capacité type" },
      { value: "90%", label: "Autoconso max" },
      { value: "10 ans", label: "Garantie" },
      { value: "6000+", label: "Cycles de vie" },
    ],
  },

  water: {
    id: "water",
    title: "Chauffe-eau thermodynamique / solaire",
    subtitle: "Divisez par 3 la consommation d'eau chaude — pour un investissement rapidement amorti.",
    hero: "https://images.unsplash.com/photo-1585771724684-38269d6639fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
    intro:
      "Ballon thermodynamique 200 à 300 L (COP 3+) ou système solaire thermique. L'eau chaude sanitaire = 15-20% de votre facture énergétique — un poste qu'il est simple d'attaquer.",
    why: [
      { title: "-65% sur l'ECS", body: "Le thermodynamique divise par 3 la consommation vs cumulus classique." },
      { title: "Éligible aides", body: "MaPrimeRénov' + CEE — reste à charge minimal." },
      { title: "Installation rapide", body: "Remplacement en une demi-journée dans la plupart des cas." },
    ],
    process: [
      { step: "01", title: "Visite technique", body: "Vérification du local (volume, température, évacuation)." },
      { step: "02", title: "Choix modèle", body: "200 L pour couple, 250-300 L pour famille." },
      { step: "03", title: "Pose", body: "Demi-journée, mise en service comprise." },
    ],
    projects: [
      {
        title: "Schéma — Cumulus électrique vs Ballon thermodynamique",
        power: "Thermodynamique 250 L · COP 3",
        result: "1 200 kWh/an → 400 kWh/an · -65% facture ECS",
        schema: "water",
      },
    ],
    testimonial: {
      quote:
        "Notre cumulus consommait énormément. Le thermodynamique a divisé la facture par 3. Payé en quelques années.",
      author: "Nadia & Jean-Pierre",
      role: "Boulogne-Billancourt",
    },
    stats: [
      { value: "COP 3+", label: "Rendement" },
      { value: "-65%", label: "Facture ECS" },
      { value: "4-6 ans", label: "Amortissement" },
    ],
  },

  bills: {
    id: "bills",
    title: "Réduire vos factures — pilotage et optimisation",
    subtitle: "Au-delà de l'équipement : audit énergétique complet pour identifier chaque source de perte.",
    hero: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
    intro:
      "Bilan énergétique détaillé de votre logement, avec caméra thermique, désembouage de circuit, pilotage intelligent des radiateurs et suivi conso en temps réel. On identifie les 20% de sources qui causent 80% de vos pertes.",
    why: [
      { title: "Audit sous 48 h", body: "Rapport clair, chiffré, avec priorisation économique." },
      { title: "Pilotage intelligent", body: "Thermostats connectés par pièce — 15% d'économies additionnelles." },
      { title: "Éligible CEE", body: "Certificats d'économies d'énergie — primes cumulables." },
    ],
    process: [
      { step: "01", title: "Visite audit", body: "Caméra thermique, mesures, bilan conso 12 mois." },
      { step: "02", title: "Plan d'action", body: "Priorités hiérarchisées : quick wins d'abord." },
      { step: "03", title: "Mise en œuvre", body: "Un seul interlocuteur — nous coordonnons tout." },
    ],
    projects: [
      {
        title: "Schéma — Maison énergivore vs après audit HMCD",
        power: "ITE + pilotage + désembouage circuit",
        result: "Facture divisée par 2 environ",
        schema: "bills",
      },
    ],
    testimonial: null,
    stats: [
      { value: "-38%", label: "Économies moyennes" },
      { value: "48 h", label: "Rapport audit" },
    ],
  },

  rewards: {
    id: "rewards",
    title: "Cumuler toutes les aides",
    subtitle: "MaPrimeRénov', CEE, éco-PTZ, TVA 5,5% — HMCD monte l'intégralité de vos dossiers.",
    hero: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
    intro:
      "En tant que mandataire administratif et financier MaPrimeRénov', nous montons les dossiers, avançons les aides et vous facturons le reste à charge — sans avance de trésorerie de votre part.",
    why: [
      { title: "MaPrimeRénov'", body: "Jusqu'à 90% du chantier pour les ménages modestes." },
      { title: "CEE", body: "Primes énergie versées par les fournisseurs." },
      { title: "Éco-PTZ", body: "Prêt à taux zéro pour les travaux énergétiques." },
      { title: "TVA 5,5%", body: "Sur tous les travaux d'amélioration énergétique." },
    ],
    process: [
      { step: "01", title: "Simulation gratuite", body: "Estimation précise des aides selon vos revenus." },
      { step: "02", title: "Montage du dossier", body: "Nous préparons et déposons pour vous." },
      { step: "03", title: "Avance des aides", body: "Vous ne payez que le reste à charge." },
    ],
    projects: [
      {
        title: "Schéma — Dossiers seul vs avec HMCD",
        power: "MaPrimeRénov' + CEE + éco-PTZ montés par nos équipes",
        result: "Zéro avance de trésorerie · dossiers acceptés",
        schema: "rewards",
      },
    ],
    testimonial: {
      quote:
        "HMCD a géré toutes les démarches. On n'a eu qu'à valider les rendus. Impeccable.",
      author: "Marc L.",
      role: "Rueil-Malmaison",
    },
    stats: [
      { value: "90%", label: "Aides max" },
      { value: "0 avance", label: "de trésorerie" },
    ],
  },

  track: {
    id: "track",
    title: "Suivre votre production",
    subtitle: "Application mobile HMCD : production, autoconso, revente — tout en direct.",
    hero: "https://images.unsplash.com/photo-1611365892117-bce8fc0f2b1e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
    intro:
      "Chaque installation HMCD est livrée avec un onduleur communicant et une app mobile pour suivre en direct : production, consommation, injection réseau, performance, alertes maintenance.",
    why: [
      { title: "Temps réel", body: "Voyez ce que vous produisez à la seconde près." },
      { title: "Historique", body: "Comparez mois par mois, année par année." },
      { title: "Alertes", body: "Baisse de production ? On vous prévient avant vous." },
    ],
    process: [],
    projects: [
      {
        title: "Schéma — Sans supervision vs App HMCD",
        power: "Application mobile temps réel + alertes",
        result: "Production tracée 24/7 · panne détectée en < 15 min",
        schema: "track",
      },
    ],
    testimonial: null,
    stats: [{ value: "24/7", label: "Monitoring" }, { value: "-15 min", label: "Alerte panne" }],
  },
};
